// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1__KS","cls2":"Timer-cls2_xV4 Timer-cls1__KS","bottom":"Timer-bottom_Oo7","top":"Timer-top_4T7","topBack":"Timer-topBack_wsg","topBehind":"Timer-topBehind_nnd"};